// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects.
// *********************************
import {
  AccountGroupInterface,
  AccountGroupsInterface,
  AssociatedLocationIDsInterface,
  BrandingInterface,
  BrandInterface,
  ContactUsRequestInterface,
  DropdownItemInterface,
  GetLanguageResponseInterface,
  GetLocationsRequestInterface,
  GetLocationsResponseInterface,
  GetNavigationDataRequestInterface,
  GetNavigationDataResponseInterface,
  GetPinsRequestInterface,
  GetPinsResponseInterface,
  GroupsInterface,
  LocationInterface,
  PinnedItemInterface,
  SalesContactInterface,
  SalesInfoInterface,
  SetLanguageRequestInterface,
  SetPinsRequestInterface,
  SideNavigationContainerInterface,
  SideNavigationItemInterface,
  SideNavigationLinkInterface,
  SideNavigationSectionInterface,
  SetDefaultLocationRequestInterface,
  ThemingInterface,
  RetentionConfigInterface,
  TotalLocationsInterface,
  ListElevatedLocationsResponseInterface,
  ListElevatedLocationsRequestInterface,
  GetSalesInfoRequestInterface,
  GetSalesInfoResponseInterface
} from './api.interface';
import { UITheme, UserViewType } from './enums';


export function enumStringToValue<E>(enumRef: any, value: string): E {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}

export class GetNavigationDataRequest implements GetNavigationDataRequestInterface {
  accountGroupId: string;
  groupPath: string;
  partnerId: string;
  marketId: string;

  static fromProto(proto: any): GetNavigationDataRequest {
    let m = new GetNavigationDataRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: GetNavigationDataRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupId === 'undefined' &&
      typeof this.groupPath === 'undefined' &&
      typeof this.partnerId === 'undefined' &&
      typeof this.marketId === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupId !== 'undefined') {
      toReturn.accountGroupId = this.accountGroupId;
    }
    if (typeof this.groupPath !== 'undefined') {
      toReturn.groupPath = this.groupPath;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn.partnerId = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn.marketId = this.marketId;
    }
    return toReturn;
  }
}

export class GetSalesInfoRequest implements GetSalesInfoRequestInterface {
  accountGroupId: string;
  groupPath: string;

  static fromProto(proto: any): GetSalesInfoRequest {
      let m = new GetSalesInfoRequest();
      m = Object.assign(m, proto);
      return m;
  }
  constructor(kwargs?: GetSalesInfoRequestInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }
  toApiJson(): object {
      if (
          typeof this.accountGroupId === 'undefined' &&
          typeof this.groupPath === 'undefined') {
          return {};
      }
      const toReturn: {
          [key: string]: any;
      } = {};
      const agid = 'accountGroupId';
      const groupPath = 'groupPath';
      if (typeof this.accountGroupId !== 'undefined') {toReturn[agid] = this.accountGroupId;}
      if (typeof this.groupPath !== 'undefined') {toReturn[groupPath] = this.groupPath;}
      return toReturn;
  }
}

export class GetSalesInfoResponse implements GetSalesInfoResponseInterface {
  salesInfo: SalesInfo;

  static fromProto(proto: any): GetSalesInfoResponse {
      let m = new GetSalesInfoResponse();
      m = Object.assign(m, proto);
      if (proto.salesInfo) {m.salesInfo = SalesInfo.fromProto(proto.salesInfo);}
      return m;
  }
  constructor(kwargs?: GetSalesInfoResponseInterface) {
      if (!kwargs) {
          return;
      }
      Object.assign(this, kwargs);
  }
  toApiJson(): object {
      if (
          typeof this.salesInfo === 'undefined') {
          return {};
      }
      const toReturn: {
          [key: string]: any;
      } = {};
      const salesInfo = 'salesInfo';
      if (typeof this.salesInfo !== 'undefined' && this.salesInfo !== null) {toReturn[salesInfo] = 'toApiJson' in this.salesInfo ? (this.salesInfo as any).toApiJson() : this.salesInfo;}
      return toReturn;
  }
}

export class SideNavigationSection implements SideNavigationSectionInterface {
  translationId: string;
  sideNavigationItems: SideNavigationItem[];
  label: string;
  chipContent: string;

  static fromProto(proto: any): SideNavigationSection {
    let m = new SideNavigationSection();
    m = Object.assign(m, proto);
    if (proto.sideNavigationItems) {
      m.sideNavigationItems = proto.sideNavigationItems.map(SideNavigationItem.fromProto);
    }
    return m;
  }

  constructor(kwargs?: SideNavigationSectionInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.translationId === 'undefined' &&
      typeof this.sideNavigationItems === 'undefined' &&
      typeof this.label === 'undefined' &&
      typeof this.chipContent === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.translationId !== 'undefined') {
      toReturn.translationId = this.translationId;
    }
    if (typeof this.sideNavigationItems !== 'undefined' && this.sideNavigationItems !== null) {
      toReturn.sideNavigationItems = 'toApiJson' in this.sideNavigationItems ? (this.sideNavigationItems as any).toApiJson() : this.sideNavigationItems;
    }
    if (typeof this.label !== 'undefined') {
      toReturn.label = this.label;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn.chipContent = this.chipContent;
    }
    return toReturn;
  }
}

export class SideNavigationContainer implements SideNavigationContainerInterface {
  translationId: string;
  sideNavigationItems: SideNavigationItem[];
  icon: string;
  logoUrl: string;
  label: string;
  showIcon: boolean;
  chipContent: string;

  static fromProto(proto: any): SideNavigationContainer {
    let m = new SideNavigationContainer();
    m = Object.assign(m, proto);
    if (proto.sideNavigationItems) {
      m.sideNavigationItems = proto.sideNavigationItems.map(SideNavigationItem.fromProto);
    }
    return m;
  }

  constructor(kwargs?: SideNavigationContainerInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.translationId === 'undefined' &&
      typeof this.sideNavigationItems === 'undefined' &&
      typeof this.icon === 'undefined' &&
      typeof this.logoUrl === 'undefined' &&
      typeof this.label === 'undefined' &&
      typeof this.showIcon === 'undefined' &&
      typeof this.chipContent === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.translationId !== 'undefined') {
      toReturn.translationId = this.translationId;
    }
    if (typeof this.sideNavigationItems !== 'undefined' && this.sideNavigationItems !== null) {
      toReturn.sideNavigationItems = 'toApiJson' in this.sideNavigationItems ? (this.sideNavigationItems as any).toApiJson() : this.sideNavigationItems;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn.icon = this.icon;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn.logoUrl = this.logoUrl;
    }
    if (typeof this.label !== 'undefined') {
      toReturn.label = this.label;
    }
    if (typeof this.showIcon !== 'undefined') {
      toReturn.showIcon = this.showIcon;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn.chipContent = this.chipContent;
    }
    return toReturn;
  }
}

export class SideNavigationLink implements SideNavigationLinkInterface {
  navigationId: string;
  url: string;
  path: string;
  serviceProviderId: string;
  logoUrl: string;
  icon: string;
  translationId: string;
  external: boolean;
  label: string;
  showIcon: boolean;
  pinnable: boolean;
  chipContent: string;
  isTrial: boolean;
  userRequired: boolean;
  ooProduct: boolean;

  static fromProto(proto: any): SideNavigationLink {
    let m = new SideNavigationLink();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: SideNavigationLinkInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.navigationId === 'undefined' &&
      typeof this.url === 'undefined' &&
      typeof this.path === 'undefined' &&
      typeof this.serviceProviderId === 'undefined' &&
      typeof this.logoUrl === 'undefined' &&
      typeof this.icon === 'undefined' &&
      typeof this.translationId === 'undefined' &&
      typeof this.external === 'undefined' &&
      typeof this.label === 'undefined' &&
      typeof this.showIcon === 'undefined' &&
      typeof this.pinnable === 'undefined' &&
      typeof this.chipContent === 'undefined' &&
      typeof this.userRequired === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.navigationId !== 'undefined') {
      toReturn.navigationId = this.navigationId;
    }
    if (typeof this.url !== 'undefined') {
      toReturn.url = this.url;
    }
    if (typeof this.path !== 'undefined') {
      toReturn.path = this.path;
    }
    if (typeof this.serviceProviderId !== 'undefined') {
      toReturn.serviceProviderId = this.serviceProviderId;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn.logoUrl = this.logoUrl;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn.icon = this.icon;
    }
    if (typeof this.translationId !== 'undefined') {
      toReturn.translationId = this.translationId;
    }
    if (typeof this.external !== 'undefined') {
      toReturn.external = this.external;
    }
    if (typeof this.label !== 'undefined') {
      toReturn.label = this.label;
    }
    if (typeof this.showIcon !== 'undefined') {
      toReturn.showIcon = this.showIcon;
    }
    if (typeof this.pinnable !== 'undefined') {
      toReturn.pinnable = this.pinnable;
    }
    if (typeof this.chipContent !== 'undefined') {
      toReturn.chipContent = this.chipContent;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn.isTrial = this.isTrial;
    }
    if (typeof this.userRequired !== 'undefined') {
      toReturn.userRequired = this.userRequired;
    }
    return toReturn;
  }
}


export class DropdownItem implements DropdownItemInterface {
  url: string;
  path: string;
  translationId: string;
  label: string;

  static fromProto(proto: any): DropdownItem {
    let m = new DropdownItem();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: DropdownItemInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.url === 'undefined' &&
      typeof this.path === 'undefined' &&
      typeof this.translationId === 'undefined' &&
      typeof this.label === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.url !== 'undefined') {
      toReturn.url = this.url;
    }
    if (typeof this.path !== 'undefined') {
      toReturn.path = this.path;
    }
    if (typeof this.translationId !== 'undefined') {
      toReturn.translationId = this.translationId;
    }
    if (typeof this.label !== 'undefined') {
      toReturn.label = this.label;
    }
    return toReturn;
  }
}

export class SideNavigationItem implements SideNavigationItemInterface {
  sideNavigationSection: SideNavigationSection;
  sideNavigationContainer: SideNavigationContainer;
  sideNavigationLink: SideNavigationLink;

  static fromProto(proto: any): SideNavigationItem {
    let m = new SideNavigationItem();
    m = Object.assign(m, proto);
    if (proto.sideNavigationSection) {
      m.sideNavigationSection = SideNavigationSection.fromProto(proto.sideNavigationSection);
    }
    if (proto.sideNavigationContainer) {
      m.sideNavigationContainer = SideNavigationContainer.fromProto(proto.sideNavigationContainer);
    }
    if (proto.sideNavigationLink) {
      m.sideNavigationLink = SideNavigationLink.fromProto(proto.sideNavigationLink);
    }
    return m;
  }

  constructor(kwargs?: SideNavigationItemInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.sideNavigationSection === 'undefined' &&
      typeof this.sideNavigationContainer === 'undefined' &&
      typeof this.sideNavigationLink === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.sideNavigationSection !== 'undefined' && this.sideNavigationSection !== null) {
      toReturn.sideNavigationSection = 'toApiJson' in this.sideNavigationSection ? (this.sideNavigationSection as any).toApiJson() : this.sideNavigationSection;
    }
    if (typeof this.sideNavigationContainer !== 'undefined' && this.sideNavigationContainer !== null) {
      toReturn.sideNavigationContainer = 'toApiJson' in this.sideNavigationContainer ? (this.sideNavigationContainer as any).toApiJson() : this.sideNavigationContainer;
    }
    if (typeof this.sideNavigationLink !== 'undefined' && this.sideNavigationLink !== null) {
      toReturn.sideNavigationLink = 'toApiJson' in this.sideNavigationLink ? (this.sideNavigationLink as any).toApiJson() : this.sideNavigationLink;
    }
    return toReturn;
  }
}

export class RetentionConfig implements RetentionConfigInterface {
  cancellationNotificationEmail: string;

  static fromProto(proto: any): RetentionConfig {
    let m = new RetentionConfig();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: RetentionConfigInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
        typeof this.cancellationNotificationEmail === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.cancellationNotificationEmail !== 'undefined') {toReturn.cancellationNotificationEmail = this.cancellationNotificationEmail;}
    return toReturn;
  }
}

export class SalesInfo implements SalesInfoInterface {
  marketName: string;
  salesContact: SalesContact;

  static fromProto(proto: any): SalesInfo {
    let m = new SalesInfo();
    m = Object.assign(m, proto);
    if (proto.salesContact) {
      m.salesContact = SalesContact.fromProto(proto.salesContact);
    }
    return m;
  }

  constructor(kwargs?: SalesInfoInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.marketName === 'undefined' &&
      typeof this.salesContact === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.marketName !== 'undefined') {
      toReturn.marketName = this.marketName;
    }
    if (typeof this.salesContact !== 'undefined' && this.salesContact !== null) {
      toReturn.salesContact = 'toApiJson' in this.salesContact ? (this.salesContact as any).toApiJson() : this.salesContact;
    }
    return toReturn;
  }
}

export class SalesContact implements SalesContactInterface {
  salesPersonId: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  photoUrlSecure: string;
  jobTitle: string;
  country: string;

  static fromProto(proto: any): SalesContact {
    let m = new SalesContact();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: SalesContactInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.salesPersonId === 'undefined' &&
      typeof this.email === 'undefined' &&
      typeof this.firstName === 'undefined' &&
      typeof this.lastName === 'undefined' &&
      typeof this.phoneNumber === 'undefined' &&
      typeof this.photoUrlSecure === 'undefined' &&
      typeof this.jobTitle === 'undefined' &&
      typeof this.country === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.salesPersonId !== 'undefined') {
      toReturn.salesPersonId = this.salesPersonId;
    }
    if (typeof this.email !== 'undefined') {
      toReturn.email = this.email;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn.firstName = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn.lastName = this.lastName;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn.phoneNumber = this.phoneNumber;
    }
    if (typeof this.photoUrlSecure !== 'undefined') {
      toReturn.photoUrlSecure = this.photoUrlSecure;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn.jobTitle = this.jobTitle;
    }
    if (typeof this.country !== 'undefined') {
      toReturn.country = this.country;
    }
    return toReturn;
  }
}

export class Brand implements BrandInterface {
  name: string;
  pathNodes: string[];
  hasAccess: boolean;
  url: string;

  static fromProto(proto: any): Brand {
    let m = new Brand();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: BrandInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.name === 'undefined' &&
      typeof this.pathNodes === 'undefined' &&
      typeof this.hasAccess === 'undefined' &&
      typeof this.url === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.name !== 'undefined') {
      toReturn.name = this.name;
    }
    if (typeof this.pathNodes !== 'undefined') {
      toReturn.pathNodes = this.pathNodes;
    }
    if (typeof this.hasAccess !== 'undefined') {
      toReturn.hasAccess = this.hasAccess;
    }
    if (typeof this.url !== 'undefined') {
      toReturn.url = this.url;
    }
    return toReturn;
  }
}

export class PinnedItem implements PinnedItemInterface {
  navigationId: string;

  static fromProto(proto: any): PinnedItem {
    let m = new PinnedItem();
    m = Object.assign(m, proto);
    return m;
  }

  static duplicate(other: PinnedItem): PinnedItem {
    return new PinnedItem({ navigationId: other.navigationId });
  }

  constructor(kwargs?: PinnedItemInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.navigationId === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.navigationId !== 'undefined') {
      toReturn.navigationId = this.navigationId;
    }
    return toReturn;
  }
}

export class Branding implements BrandingInterface {
  theme: UITheme;
  logoUrl: string;
  partnerName: string;
  centerName: string;
  theming: Theming;
  cobrandingLogoUrl: string;
  marketName: string;

  static fromProto(proto: any): Branding {
    let m = new Branding();
    m = Object.assign(m, proto);
    if (proto.theme) {
      m.theme = enumStringToValue<UITheme>(UITheme, proto.theme);
    }
    if (proto.theming) {
      m.theming = Theming.fromProto(proto.theming);
    }
    if (proto.cobrandingLogoUrl) {
      m.cobrandingLogoUrl = proto.cobrandingLogoUrl;
    }
    return m;
  }

  constructor(kwargs?: BrandingInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.theme === 'undefined' &&
      typeof this.logoUrl === 'undefined' &&
      typeof this.partnerName === 'undefined' &&
      typeof this.centerName === 'undefined' &&
      typeof this.theming === 'undefined' &&
      typeof this.cobrandingLogoUrl === 'undefined' &&
      typeof this.marketName === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.theme !== 'undefined') {
      toReturn.theme = this.theme;
    }
    if (typeof this.logoUrl !== 'undefined') {
      toReturn.logoUrl = this.logoUrl;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn.partnerName = this.partnerName;
    }
    if (typeof this.centerName !== 'undefined') {
      toReturn.centerName = this.centerName;
    }
    if (typeof this.theming !== 'undefined') {
      toReturn.theming = this.theming;
    }
    if (typeof this.cobrandingLogoUrl !== 'undefined') {
      toReturn.cobrandingLogoUrl = this.cobrandingLogoUrl;
    }
    if (typeof this.marketName !== 'undefined') {
      toReturn.marketName = this.marketName;
    }
    return toReturn;
  }
}

export class AccountGroup implements AccountGroupInterface {
  accountGroupId: string;
  name: string;
  address: string;
  activatedProductIds: string[];
  url: string;

  static fromProto(proto: any): AccountGroup {
    let m = new AccountGroup();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: AccountGroupInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupId === 'undefined' &&
      typeof this.name === 'undefined' &&
      typeof this.address === 'undefined' &&
      typeof this.activatedProductIds === 'undefined' &&
      typeof this.url === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupId !== 'undefined') {
      toReturn.accountGroupId = this.accountGroupId;
    }
    if (typeof this.name !== 'undefined') {
      toReturn.name = this.name;
    }
    if (typeof this.address !== 'undefined') {
      toReturn.address = this.address;
    }
    if (typeof this.activatedProductIds !== 'undefined') {
      toReturn.activatedProductIds = this.activatedProductIds;
    }
    if (typeof this.url !== 'undefined') {
      toReturn.url = this.url;
    }
    return toReturn;
  }
}

export class Location implements LocationInterface {
  accountGroup: AccountGroup;
  brand: Brand;

  static fromProto(proto: any): Location {
    let m = new Location();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = AccountGroup.fromProto(proto.accountGroup);
    }
    if (proto.brand) {
      m.brand = Brand.fromProto(proto.brand);
    }
    return m;
  }

  constructor(kwargs?: LocationInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroup === 'undefined' &&
      typeof this.brand === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn.accountGroup = 'toApiJson' in this.accountGroup ? (this.accountGroup as any).toApiJson() : this.accountGroup;
    }
    if (typeof this.brand !== 'undefined' && this.brand !== null) {
      toReturn.brand = 'toApiJson' in this.brand ? (this.brand as any).toApiJson() : this.brand;
    }
    return toReturn;
  }
}

export class GetNavigationDataResponse implements GetNavigationDataResponseInterface {
  accountItems: SideNavigationItem[];
  branding: Branding;
  salesInfo: SalesInfo;
  pinnedItems: PinnedItem[];
  associatedLocationIds: AssociatedLocationIDs;
  defaultLocation: string;
  brandItems: SideNavigationItem[];
  language: string;
  dropdownItems: DropdownItem[];
  currentBrandName: string;
  userView: UserViewType;
  retentionConfig: RetentionConfig;
  totalLocations: TotalLocations;
  userId: string;
  businessAppBranding: boolean;

  static fromProto(proto: any): GetNavigationDataResponse {
    let m = new GetNavigationDataResponse();
    m = Object.assign(m, proto);
    if (proto.accountItems) {m.accountItems = proto.accountItems.map(SideNavigationItem.fromProto);}
    if (proto.branding) {m.branding = Branding.fromProto(proto.branding);}
    if (proto.salesInfo) {m.salesInfo = SalesInfo.fromProto(proto.salesInfo);}
    if (proto.pinnedItems) {m.pinnedItems = proto.pinnedItems.map(PinnedItem.fromProto);}
    if (proto.associatedLocationIds) {m.associatedLocationIds = AssociatedLocationIDs.fromProto(proto.associatedLocationIds);}
    if (proto.brandItems) {m.brandItems = proto.brandItems.map(SideNavigationItem.fromProto);}
    if (proto.dropdownItems) {m.dropdownItems = proto.dropdownItems.map(DropdownItem.fromProto);}
    if (proto.userView) {m.userView = enumStringToValue<UserViewType>(UserViewType, proto.userView);}
    if (proto.retentionConfig) {m.retentionConfig = RetentionConfig.fromProto(proto.retentionConfig);}
    if (proto.totalLocations) {m.totalLocations = TotalLocations.fromProto(proto.totalLocations);}
    return m;
  }

  constructor(kwargs?: GetNavigationDataResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
        typeof this.accountItems === 'undefined' &&
        typeof this.branding === 'undefined' &&
        typeof this.salesInfo === 'undefined' &&
        typeof this.pinnedItems === 'undefined' &&
        typeof this.associatedLocationIds === 'undefined' &&
        typeof this.defaultLocation === 'undefined' &&
        typeof this.brandItems === 'undefined' &&
        typeof this.language === 'undefined' &&
        typeof this.dropdownItems === 'undefined' &&
        typeof this.currentBrandName === 'undefined' &&
        typeof this.userView === 'undefined' &&
        typeof this.retentionConfig === 'undefined' &&
        typeof this.totalLocations === 'undefined' &&
        typeof this.userId === 'undefined' &&
        typeof this.businessAppBranding === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountItems !== 'undefined' && this.accountItems !== null) {
      toReturn.accountItems = 'toApiJson' in this.accountItems ? (this.accountItems as any).toApiJson() : this.accountItems;
    }
    if (typeof this.branding !== 'undefined' && this.branding !== null) {
      toReturn.branding = 'toApiJson' in this.branding ? (this.branding as any).toApiJson() : this.branding;
    }
    if (typeof this.salesInfo !== 'undefined' && this.salesInfo !== null) {
      toReturn.salesInfo = 'toApiJson' in this.salesInfo ? (this.salesInfo as any).toApiJson() : this.salesInfo;
    }
    if (typeof this.pinnedItems !== 'undefined' && this.pinnedItems !== null) {
      toReturn.pinnedItems = 'toApiJson' in this.pinnedItems ? (this.pinnedItems as any).toApiJson() : this.pinnedItems;
    }
    if (typeof this.associatedLocationIds !== 'undefined' && this.associatedLocationIds !== null) {
      toReturn.associatedLocationIds = 'toApiJson' in this.associatedLocationIds ? (this.associatedLocationIds as any).toApiJson() : this.associatedLocationIds;
    }
    if (typeof this.defaultLocation !== 'undefined') {
      toReturn.defaultLocation = this.defaultLocation;
    }
    if (typeof this.brandItems !== 'undefined' && this.brandItems !== null) {
      toReturn.brandItems = 'toApiJson' in this.brandItems ? (this.brandItems as any).toApiJson() : this.brandItems;
    }
    if (typeof this.language !== 'undefined') {
      toReturn.language = this.language;
    }
    if (typeof this.dropdownItems !== 'undefined' && this.dropdownItems !== null) {
      toReturn.dropdownItems = 'toApiJson' in this.dropdownItems ? (this.dropdownItems as any).toApiJson() : this.dropdownItems;
    }
    if (typeof this.currentBrandName !== 'undefined') {
      toReturn.currentBrandName = this.currentBrandName;
    }
    if (typeof this.userView !== 'undefined') {
      toReturn.userView = this.userView;
    }
    if (typeof this.retentionConfig !== 'undefined' && this.retentionConfig !== null) {
      toReturn.retentionConfig = 'toApiJson' in this.retentionConfig ? (this.retentionConfig as any).toApiJson() : this.retentionConfig;
    }
    if (typeof this.totalLocations !== 'undefined' && this.totalLocations !== null) {
      toReturn.totalLocations = 'toApiJson' in this.totalLocations ? (this.totalLocations as any).toApiJson() : this.totalLocations;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn.userId = this.userId;
    }
    if (typeof this.businessAppBranding !== 'undefined') {
      toReturn.businessAppBranding = this.businessAppBranding;
    }
    return toReturn;
  }
}

export class SetPinsRequest implements SetPinsRequestInterface {
  identifier: string;
  items: PinnedItem[];

  static fromProto(proto: any): SetPinsRequest {
    let m = new SetPinsRequest();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(PinnedItem.fromProto);
    }
    return m;
  }

  constructor(kwargs?: SetPinsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.identifier === 'undefined' &&
      typeof this.items === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.identifier !== 'undefined') {
      toReturn.identifier = this.identifier;
    }
    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn.items = 'toApiJson' in this.items ? (this.items as any).toApiJson() : this.items;
    }
    return toReturn;
  }
}

export class GetPinsRequest implements GetPinsRequestInterface {
  identifier: string;

  static fromProto(proto: any): GetPinsRequest {
    let m = new GetPinsRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: GetPinsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.identifier === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.identifier !== 'undefined') {
      toReturn.identifier = this.identifier;
    }
    return toReturn;
  }
}

export class GetPinsResponse implements GetPinsResponseInterface {
  items: PinnedItem[];

  static fromProto(proto: any): GetPinsResponse {
    let m = new GetPinsResponse();
    m = Object.assign(m, proto);
    if (proto.items) {
      m.items = proto.items.map(PinnedItem.fromProto);
    }
    return m;
  }

  constructor(kwargs?: GetPinsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.items === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.items !== 'undefined' && this.items !== null) {
      toReturn.items = 'toApiJson' in this.items ? (this.items as any).toApiJson() : this.items;
    }
    return toReturn;
  }
}


export class AccountGroups implements AccountGroupsInterface {
  accountGroupIds: string[];

  static fromProto(proto: any): AccountGroups {
    let m = new AccountGroups();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: AccountGroupsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupIds === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn.accountGroupIds = this.accountGroupIds;
    }
    return toReturn;
  }
}


export class AssociatedLocationIDs implements AssociatedLocationIDsInterface {
  accountGroupIds: string[];
  groupPaths: string[];

  static fromProto(proto: any): AssociatedLocationIDs {
    let m = new AssociatedLocationIDs();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: AssociatedLocationIDsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupIds === 'undefined' &&
      typeof this.groupPaths === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn.accountGroupIds = this.accountGroupIds;
    }
    if (typeof this.groupPaths !== 'undefined') {
      toReturn.groupPaths = this.groupPaths;
    }
    return toReturn;
  }
}

export class Groups implements GroupsInterface {
  groupPaths: string[];

  static fromProto(proto: any): Groups {
    let m = new Groups();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: GroupsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.groupPaths === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.groupPaths !== 'undefined') {
      toReturn.groupPaths = this.groupPaths;
    }
    return toReturn;
  }
}


export class GetLocationsRequest implements GetLocationsRequestInterface {
  accountGroups: AccountGroups;
  groups: Groups;

  static fromProto(proto: any): GetLocationsRequest {
    let m = new GetLocationsRequest();
    m = Object.assign(m, proto);
    if (proto.accountGroups) {
      m.accountGroups = AccountGroups.fromProto(proto.accountGroups);
    }
    if (proto.groups) {
      m.groups = Groups.fromProto(proto.groups);
    }
    return m;
  }

  constructor(kwargs?: GetLocationsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroups === 'undefined' &&
      typeof this.groups === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroups !== 'undefined' && this.accountGroups !== null) {
      toReturn.accountGroups = 'toApiJson' in this.accountGroups ? (this.accountGroups as any).toApiJson() : this.accountGroups;
    }
    if (typeof this.groups !== 'undefined' && this.groups !== null) {
      toReturn.groups = 'toApiJson' in this.groups ? (this.groups as any).toApiJson() : this.groups;
    }
    return toReturn;
  }
}

export class GetLocationsResponse implements GetLocationsResponseInterface {
  locations: Location[];

  static fromProto(proto: any): GetLocationsResponse {
    let m = new GetLocationsResponse();
    m = Object.assign(m, proto);
    if (proto.locations) {
      m.locations = proto.locations.map(Location.fromProto);
    }
    return m;
  }

  constructor(kwargs?: GetLocationsResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.locations === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.locations !== 'undefined' && this.locations !== null) {
      toReturn.locations = 'toApiJson' in this.locations ? (this.locations as any).toApiJson() : this.locations;
    }
    return toReturn;
  }
}


export class SetLanguageRequest implements SetLanguageRequestInterface {
  language: string;

  static fromProto(proto: any): SetLanguageRequest {
    let m = new SetLanguageRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: SetLanguageRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.language === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.language !== 'undefined') {
      toReturn.language = this.language;
    }
    return toReturn;
  }
}

export class GetLanguageRequest {

  static fromProto(proto: any): GetLanguageRequest {
    let m = new GetLanguageRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: any) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    const toReturn: {
      [key: string]: any;
    } = {};

    return toReturn;
  }
}

export class GetLanguageResponse implements GetLanguageResponseInterface {
  language: string;

  static fromProto(proto: any): GetLanguageResponse {
    let m = new GetLanguageResponse();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: GetLanguageResponseInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.language === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.language !== 'undefined') {
      toReturn.language = this.language;
    }
    return toReturn;
  }
}

export class ContactUsRequest implements ContactUsRequestInterface {
  accountGroupId: string;
  message: string;

  static fromProto(proto: any): ContactUsRequest {
    let m = new ContactUsRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: ContactUsRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupId === 'undefined' &&
      typeof this.message === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupId !== 'undefined') {
      toReturn.accountGroupId = this.accountGroupId;
    }
    if (typeof this.message !== 'undefined') {
      toReturn.message = this.message;
    }
    return toReturn;
  }
}

export class SetDefaultLocationRequest implements SetDefaultLocationRequestInterface {
  accountGroupId: string;
  partnerId: string;

  static fromProto(proto: any): SetDefaultLocationRequest {
    let m = new SetDefaultLocationRequest();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: SetDefaultLocationRequestInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.accountGroupId === 'undefined' &&
      typeof this.partnerId === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accountGroupId !== 'undefined') {
      toReturn.accountGroupId = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn.partnerId = this.partnerId;
    }
    return toReturn;
  }
}

export class Theming implements ThemingInterface {
  primaryColor: string;
  primaryHoverColor: string;
  primaryActiveColor: string;
  secondaryColor: string;
  secondaryHoverColor: string;
  secondaryActiveColor: string;
  fontColor: string;
  fontDisabledColor: string;
  accentsColor: string;
  accentsActiveColor: string;
  focusColor: string;
  borderColor: string;

  static fromProto(proto: any): Theming {
    let m = new Theming();
    m = Object.assign(m, proto);
    return m;
  }

  constructor(kwargs?: ThemingInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
      typeof this.primaryColor === 'undefined' &&
      typeof this.primaryHoverColor === 'undefined' &&
      typeof this.primaryActiveColor === 'undefined' &&
      typeof this.secondaryColor === 'undefined' &&
      typeof this.secondaryHoverColor === 'undefined' &&
      typeof this.secondaryActiveColor === 'undefined' &&
      typeof this.fontColor === 'undefined' &&
      typeof this.fontDisabledColor === 'undefined' &&
      typeof this.accentsColor === 'undefined' &&
      typeof this.accentsActiveColor === 'undefined' &&
      typeof this.focusColor === 'undefined' &&
      typeof this.borderColor === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.primaryColor !== 'undefined') {
      toReturn.primaryColor = this.primaryColor;
    }
    if (typeof this.primaryHoverColor !== 'undefined') {
      toReturn.primaryHoverColor = this.primaryHoverColor;
    }
    if (typeof this.primaryActiveColor !== 'undefined') {
      toReturn.primaryActiveColor = this.primaryActiveColor;
    }
    if (typeof this.secondaryColor !== 'undefined') {
      toReturn.secondaryColor = this.secondaryColor;
    }
    if (typeof this.secondaryHoverColor !== 'undefined') {
      toReturn.secondaryHoverColor = this.secondaryHoverColor;
    }
    if (typeof this.secondaryActiveColor !== 'undefined') {
      toReturn.secondaryActiveColor = this.secondaryActiveColor;
    }
    if (typeof this.fontColor !== 'undefined') {
      toReturn.fontColor = this.fontColor;
    }
    if (typeof this.fontDisabledColor !== 'undefined') {
      toReturn.fontDisabledColor = this.fontDisabledColor;
    }
    if (typeof this.accentsColor !== 'undefined') {
      toReturn.accentsColor = this.accentsColor;
    }
    if (typeof this.accentsActiveColor !== 'undefined') {
      toReturn.accentsActiveColor = this.accentsActiveColor;
    }
    if (typeof this.focusColor !== 'undefined') {
      toReturn.focusColor = this.focusColor;
    }
    if (typeof this.borderColor !== 'undefined') {
      toReturn.borderColor = this.borderColor;
    }
    return toReturn;
  }
}

export class TotalLocations implements TotalLocationsInterface {
  accounts: number;
  brands: number;

  static fromProto(proto: any): TotalLocations {
    let m = new TotalLocations();
    m = Object.assign(m, proto);
    if (proto.accounts) {m.accounts = parseInt(proto.accounts, 10);}
    if (proto.brands) {m.brands = parseInt(proto.brands, 10);}
    return m;
  }

  constructor(kwargs?: TotalLocationsInterface) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }

  toApiJson(): object {
    if (
        typeof this.accounts === 'undefined' &&
        typeof this.brands === 'undefined') {
      return {};
    }

    const toReturn: {
      [key: string]: any;
    } = {};

    if (typeof this.accounts !== 'undefined') {toReturn.accounts = this.accounts;}
    if (typeof this.brands !== 'undefined') {toReturn.brands = this.brands;}
    return toReturn;
  }
}

export class ListElevatedLocationsRequest implements ListElevatedLocationsRequestInterface {
    partnerId: string;
    cursor: string;
    pageSize: number;
    search: string;
    accountGroups: boolean;
    brands: boolean;

    static fromProto(proto: any): ListElevatedLocationsRequest {
        let m = new ListElevatedLocationsRequest();
        m = Object.assign(m, proto);
        if (proto.pageSize) {m.pageSize = parseInt(proto.pageSize, 10);}
        return m;
    }

    constructor(kwargs?: ListElevatedLocationsRequestInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
          typeof this.partnerId === 'undefined' &&
          typeof this.cursor === 'undefined' &&
          typeof this.pageSize === 'undefined' &&
          typeof this.search === 'undefined' &&
          typeof this.accountGroups === 'undefined' &&
          typeof this.brands === 'undefined') {
            return {};
        }

        const toReturn: {
            [key: string]: any;
        } = {};

        if (typeof this.partnerId !== 'undefined') {toReturn.partnerId = this.partnerId;}
        if (typeof this.cursor !== 'undefined') {toReturn.cursor = this.cursor;}
        if (typeof this.pageSize !== 'undefined') {toReturn.pageSize = this.pageSize;}
        if (typeof this.search !== 'undefined') {toReturn.search = this.search;}
        if (typeof this.accountGroups !== 'undefined') {toReturn.accountGroups = this.accountGroups;}
        if (typeof this.brands !== 'undefined') {toReturn.brands = this.brands;}
        return toReturn;
    }
}

export class ListElevatedLocationsResponse implements ListElevatedLocationsResponseInterface {
    locations: Location[];
    cursor: string;
    hasMore: boolean;

    static fromProto(proto: any): ListElevatedLocationsResponse {
        let m = new ListElevatedLocationsResponse();
        m = Object.assign(m, proto);
        if (proto.locations) {m.locations = proto.locations.map(Location.fromProto);}
        return m;
    }

    constructor(kwargs?: ListElevatedLocationsResponseInterface) {
        if (!kwargs) {
            return;
        }
        Object.assign(this, kwargs);
    }

    toApiJson(): object {
        if (
          typeof this.locations === 'undefined' &&
          typeof this.cursor === 'undefined' &&
          typeof this.hasMore === 'undefined') {
            return {};
        }

        const toReturn: {
            [key: string]: any;
        } = {};

        if (typeof this.locations !== 'undefined' && this.locations !== null) {toReturn.locations = 'toApiJson' in this.locations ? (this.locations as any).toApiJson() : this.locations;}
        if (typeof this.cursor !== 'undefined') {toReturn.cursor = this.cursor;}
        if (typeof this.hasMore !== 'undefined') {toReturn.hasMore = this.hasMore;}
        return toReturn;
    }
}
